export interface Verse {
  number: number
  text: string
}

export interface Chapter {
  number: number
  verses: Verse[]
}

export interface Book {
  name: string
  chapters: Chapter[]
  totalVerses: number
  hasAnnotations: boolean
  hasCitations: boolean
  lastReadChapter?: number
  lastReadVerse?: number
}

export interface Testament {
  name: 'Antigo Testamento' | 'Novo Testamento'
  books: Book[]
}

// Helper to calculate total verses for a book
const calculateTotalVerses = (chapters: Chapter[]): number => {
  return chapters.reduce((sum, chapter) => sum + chapter.verses.length, 0)
}

export const mockBiblia: Testament[] = [
  {
    name: 'Antigo Testamento',
    books: [
      {
        name: 'Gênesis',
        chapters: [
          {
            number: 1,
            verses: [
              { number: 1, text: 'No princípio, Deus criou os céus e a terra.' },
              {
                number: 2,
                text: 'A terra, porém, estava sem forma e vazia; havia trevas sobre a face do abismo, e o Espírito de Deus pairava por sobre as águas.',
              },
              { number: 3, text: 'Disse Deus: Haja luz; e houve luz.' },
              {
                number: 4,
                text: 'E viu Deus que a luz era boa; e fez separação entre a luz e as trevas.',
              },
              {
                number: 5,
                text: 'E chamou Deus à luz Dia; e às trevas chamou Noite. E foi a tarde e a manhã, o dia primeiro.',
              },
            ],
          },
          {
            number: 2,
            verses: [
              {
                number: 1,
                text: 'Assim, pois, foram acabados os céus e a terra e todo o seu exército.',
              },
              {
                number: 2,
                text: 'E, havendo Deus terminado no sétimo dia a sua obra, que fizera, descansou nesse dia de toda a sua obra que tinha feito.',
              },
              {
                number: 3,
                text: 'E abençoou Deus o dia sétimo, e o santificou; porque nele descansou de toda a sua obra, que Deus criara e fizera.',
              },
              {
                number: 4,
                text: 'Estas são as origens dos céus e da terra, quando foram criados; no dia em que o Senhor Deus fez a terra e os céus.',
              },
            ],
          },
          {
            number: 3,
            verses: [
              {
                number: 1,
                text: 'Ora, a serpente era mais astuta que todas as alimárias do campo que o Senhor Deus tinha feito. E esta disse à mulher: É assim que Deus disse: Não comereis de toda a árvore do jardim?',
              },
              {
                number: 2,
                text: 'E disse a mulher à serpente: Do fruto das árvores do jardim comeremos,',
              },
            ],
          },
        ],
        totalVerses: calculateTotalVerses([
          {
            number: 1,
            verses: [
              { number: 1, text: 'No princípio, Deus criou os céus e a terra.' },
              {
                number: 2,
                text: 'A terra, porém, estava sem forma e vazia; havia trevas sobre a face do abismo, e o Espírito de Deus pairava por sobre as águas.',
              },
              { number: 3, text: 'Disse Deus: Haja luz; e houve luz.' },
              {
                number: 4,
                text: 'E viu Deus que a luz era boa; e fez separação entre a luz e as trevas.',
              },
              {
                number: 5,
                text: 'E chamou Deus à luz Dia; e às trevas chamou Noite. E foi a tarde e a manhã, o dia primeiro.',
              },
            ],
          },
          {
            number: 2,
            verses: [
              {
                number: 1,
                text: 'Assim, pois, foram acabados os céus e a terra e todo o seu exército.',
              },
              {
                number: 2,
                text: 'E, havendo Deus terminado no sétimo dia a sua obra, que fizera, descansou nesse dia de toda a sua obra que tinha feito.',
              },
              {
                number: 3,
                text: 'E abençoou Deus o dia sétimo, e o santificou; porque nele descansou de toda a sua obra, que Deus criara e fizera.',
              },
              {
                number: 4,
                text: 'Estas são as origens dos céus e da terra, quando foram criados; no dia em que o Senhor Deus fez a terra e os céus.',
              },
            ],
          },
          {
            number: 3,
            verses: [
              {
                number: 1,
                text: 'Ora, a serpente era mais astuta que todas as alimárias do campo que o Senhor Deus tinha feito. E esta disse à mulher: É assim que Deus disse: Não comereis de toda a árvore do jardim?',
              },
              {
                number: 2,
                text: 'E disse a mulher à serpente: Do fruto das árvores do jardim comeremos,',
              },
            ],
          },
        ]),
        hasAnnotations: true,
        hasCitations: false,
        lastReadChapter: 1,
        lastReadVerse: 3,
      },
      {
        name: 'Êxodo',
        chapters: [
          {
            number: 1,
            verses: [
              {
                number: 1,
                text: 'São estes os nomes dos filhos de Israel que entraram no Egito com Jacó; cada um entrou com sua família:',
              },
              { number: 2, text: 'Rúben, Simeão, Levi e Judá;' },
              { number: 3, text: 'Issacar, Zebulom e Benjamim;' },
              { number: 4, text: 'Dã e Naftali, Gade e Aser.' },
            ],
          },
          {
            number: 2,
            verses: [
              { number: 1, text: 'Foi-se um homem da casa de Levi e casou com uma filha de Levi.' },
              {
                number: 2,
                text: 'E a mulher concebeu e deu à luz um filho; e, vendo que ele era formoso, escondeu-o três meses.',
              },
            ],
          },
        ],
        totalVerses: calculateTotalVerses([
          {
            number: 1,
            verses: [
              {
                number: 1,
                text: 'São estes os nomes dos filhos de Israel que entraram no Egito com Jacó; cada um entrou com sua família:',
              },
              { number: 2, text: 'Rúben, Simeão, Levi e Judá;' },
              { number: 3, text: 'Issacar, Zebulom e Benjamim;' },
              { number: 4, text: 'Dã e Naftali, Gade e Aser.' },
            ],
          },
          {
            number: 2,
            verses: [
              { number: 1, text: 'Foi-se um homem da casa de Levi e casou com uma filha de Levi.' },
              {
                number: 2,
                text: 'E a mulher concebeu e deu à luz um filho; e, vendo que ele era formoso, escondeu-o três meses.',
              },
            ],
          },
        ]),
        hasAnnotations: false,
        hasCitations: true,
        lastReadChapter: 1,
        lastReadVerse: 1,
      },
      {
        name: 'Levítico',
        chapters: [
          {
            number: 1,
            verses: [
              {
                number: 1,
                text: 'E chamou o Senhor a Moisés, e falou com ele da tenda da congregação, dizendo:',
              },
              {
                number: 2,
                text: 'Fala aos filhos de Israel, e dize-lhes: Quando algum de vós oferecer oferta ao Senhor, oferecereis a vossa oferta de gado, de gado miúdo ou de gado vacum.',
              },
            ],
          },
        ],
        totalVerses: calculateTotalVerses([
          {
            number: 1,
            verses: [
              {
                number: 1,
                text: 'E chamou o Senhor a Moisés, e falou com ele da tenda da congregação, dizendo:',
              },
              {
                number: 2,
                text: 'Fala aos filhos de Israel, e dize-lhes: Quando algum de vós oferecer oferta ao Senhor, oferecereis a vossa oferta de gado, de gado miúdo ou de gado vacum.',
              },
            ],
          },
        ]),
        hasAnnotations: false,
        hasCitations: false,
      },
      {
        name: 'Números',
        chapters: [
          {
            number: 1,
            verses: [
              {
                number: 1,
                text: 'Falou o Senhor a Moisés no deserto do Sinai, na tenda da congregação, no primeiro dia do segundo mês, no segundo ano da sua saída da terra do Egito, dizendo:',
              },
            ],
          },
        ],
        totalVerses: calculateTotalVerses([
          {
            number: 1,
            verses: [
              {
                number: 1,
                text: 'Falou o Senhor a Moisés no deserto do Sinai, na tenda da congregação, no primeiro dia do segundo mês, no segundo ano da sua saída da terra do Egito, dizendo:',
              },
            ],
          },
        ]),
        hasAnnotations: true,
        hasCitations: false,
      },
    ],
  },
  {
    name: 'Novo Testamento',
    books: [
      {
        name: 'Mateus',
        chapters: [
          {
            number: 1,
            verses: [
              {
                number: 1,
                text: 'Livro da genealogia de Jesus Cristo, filho de Davi, filho de Abraão.',
              },
              {
                number: 2,
                text: 'Abraão gerou Isaque; Isaque gerou Jacó; Jacó gerou Judá e seus irmãos.',
              },
              {
                number: 3,
                text: 'Judá gerou Perez e Zerá, de Tamar; Perez gerou Esrom; Esrom gerou Arão.',
              },
              {
                number: 4,
                text: 'Arão gerou Aminadabe; Aminadabe gerou Naassom; Naassom gerou Salmom.',
              },
              {
                number: 5,
                text: 'Salmom gerou Boaz, de Raabe; Boaz gerou Obede, de Rute; Obede gerou Jessé.',
              },
            ],
          },
          {
            number: 2,
            verses: [
              {
                number: 1,
                text: 'Tendo Jesus nascido em Belém da Judeia, em dias do rei Herodes, eis que vieram uns magos do Oriente a Jerusalém.',
              },
              {
                number: 2,
                text: 'E perguntavam: Onde está o recém-nascido Rei dos judeus? Porque vimos a sua estrela no Oriente e viemos para adorá-lo.',
              },
              {
                number: 3,
                text: 'Ouvindo isso, o rei Herodes perturbou-se, e com ele toda a Jerusalém.',
              },
            ],
          },
          {
            number: 3,
            verses: [
              {
                number: 1,
                text: 'Naqueles dias, apareceu João Batista pregando no deserto da Judeia.',
              },
              { number: 2, text: 'E dizia: Arrependei-vos, porque é chegado o Reino dos céus.' },
            ],
          },
        ],
        totalVerses: calculateTotalVerses([
          {
            number: 1,
            verses: [
              {
                number: 1,
                text: 'Livro da genealogia de Jesus Cristo, filho de Davi, filho de Abraão.',
              },
              {
                number: 2,
                text: 'Abraão gerou Isaque; Isaque gerou Jacó; Jacó gerou Judá e seus irmãos.',
              },
              {
                number: 3,
                text: 'Judá gerou Perez e Zerá, de Tamar; Perez gerou Esrom; Esrom gerou Arão.',
              },
              {
                number: 4,
                text: 'Arão gerou Aminadabe; Aminadabe gerou Naassom; Naassom gerou Salmom.',
              },
              {
                number: 5,
                text: 'Salmom gerou Boaz, de Raabe; Boaz gerou Obede, de Rute; Obede gerou Jessé.',
              },
            ],
          },
          {
            number: 2,
            verses: [
              {
                number: 1,
                text: 'Tendo Jesus nascido em Belém da Judeia, em dias do rei Herodes, eis que vieram uns magos do Oriente a Jerusalém.',
              },
              {
                number: 2,
                text: 'E perguntavam: Onde está o recém-nascido Rei dos judeus? Porque vimos a sua estrela no Oriente e viemos para adorá-lo.',
              },
              {
                number: 3,
                text: 'Ouvindo isso, o rei Herodes perturbou-se, e com ele toda a Jerusalém.',
              },
            ],
          },
          {
            number: 3,
            verses: [
              {
                number: 1,
                text: 'Naqueles dias, apareceu João Batista pregando no deserto da Judeia.',
              },
              { number: 2, text: 'E dizia: Arrependei-vos, porque é chegado o Reino dos céus.' },
            ],
          },
        ]),
        hasAnnotations: false,
        hasCitations: false,
        lastReadChapter: 2,
        lastReadVerse: 1,
      },
      {
        name: 'Marcos',
        chapters: [
          {
            number: 1,
            verses: [
              { number: 1, text: 'Princípio do evangelho de Jesus Cristo, Filho de Deus.' },
              {
                number: 2,
                text: 'Conforme está escrito no profeta Isaías: Eis que envio o meu mensageiro diante da tua face, o qual preparará o teu caminho.',
              },
              {
                number: 3,
                text: 'Voz do que clama no deserto: Preparai o caminho do Senhor, endireitai as suas veredas.',
              },
            ],
          },
          {
            number: 2,
            verses: [
              {
                number: 1,
                text: 'Alguns dias depois, entrou Jesus de novo em Cafarnaum, e soube-se que ele estava em casa.',
              },
              {
                number: 2,
                text: 'E ajuntou-se tanta gente que nem mesmo à porta eles achavam lugar; e ele lhes pregava a palavra.',
              },
            ],
          },
        ],
        totalVerses: calculateTotalVerses([
          {
            number: 1,
            verses: [
              { number: 1, text: 'Princípio do evangelho de Jesus Cristo, Filho de Deus.' },
              {
                number: 2,
                text: 'Conforme está escrito no profeta Isaías: Eis que envio o meu mensageiro diante da tua face, o qual preparará o teu caminho.',
              },
              {
                number: 3,
                text: 'Voz do que clama no deserto: Preparai o caminho do Senhor, endireitai as suas veredas.',
              },
            ],
          },
          {
            number: 2,
            verses: [
              {
                number: 1,
                text: 'Alguns dias depois, entrou Jesus de novo em Cafarnaum, e soube-se que ele estava em casa.',
              },
              {
                number: 2,
                text: 'E ajuntou-se tanta gente que nem mesmo à porta eles achavam lugar; e ele lhes pregava a palavra.',
              },
            ],
          },
        ]),
        hasAnnotations: true,
        hasCitations: true,
        lastReadChapter: 1,
        lastReadVerse: 2,
      },
      {
        name: 'Lucas',
        chapters: [
          {
            number: 1,
            verses: [
              {
                number: 1,
                text: 'Visto que muitos houve que empreenderam uma narração coordenada dos fatos que entre nós se cumpriram.',
              },
              {
                number: 2,
                text: 'Segundo nos transmitiram os que desde o princípio viram com os próprios olhos e foram ministros da palavra.',
              },
            ],
          },
        ],
        totalVerses: calculateTotalVerses([
          {
            number: 1,
            verses: [
              {
                number: 1,
                text: 'Visto que muitos houve que empreenderam uma narração coordenada dos fatos que entre nós se cumpriram.',
              },
              {
                number: 2,
                text: 'Segundo nos transmitiram os que desde o princípio viram com os próprios olhos e foram ministros da palavra.',
              },
            ],
          },
        ]),
        hasAnnotations: false,
        hasCitations: false,
      },
      {
        name: 'João',
        chapters: [
          {
            number: 1,
            verses: [
              {
                number: 1,
                text: 'No princípio era o Verbo, e o Verbo estava com Deus, e o Verbo era Deus.',
              },
            ],
          },
        ],
        totalVerses: calculateTotalVerses([
          {
            number: 1,
            verses: [
              {
                number: 1,
                text: 'No princípio era o Verbo, e o Verbo estava com Deus, e o Verbo era Deus.',
              },
            ],
          },
        ]),
        hasAnnotations: true,
        hasCitations: false,
      },
    ],
  },
]
